import { createAction } from 'typesafe-actions';
import { ContextMenuElem, ContextMenuHandler } from './types';

export const showContextMenu = createAction(
  '@components/showContextMenu',
)<ContextMenuElem>();

export const handleShowContextMenu: ContextMenuHandler<
  typeof showContextMenu
> = (state, action) => {
  return {
    ...state,
    currentContextMenu: action.payload,
  };
};
